export function identity<T>(value: T) {
  return value;
}

export function excludeNullishElements<T>(
  array: (T | null | undefined)[]
): T[] {
  return array.filter((item): item is T => item != null);
}

export function range(n: number) {
  return Array.from(Array(n), (_, index) => index);
}

export function last<T>(array?: T[]): T | undefined {
  return array ? array[array.length - 1] : undefined;
}

export function head<T>(array?: T[]): T | undefined {
  return array ? array[0] : undefined;
}

export function isTuple1<T>(array: T[]): array is [T] {
  return array.length === 1;
}

export function isTuple2<T>(array: T[]): array is [T, T] {
  return array.length === 2;
}

export function insertToSet<T>(
  array: T[],
  element: T,
  key: (value: T) => unknown = identity
) {
  if (array.some((v) => key(v) === key(element))) return array;
  return [...array, element];
}

export function removeFromSet<T>(
  array: T[],
  element: T,
  key: (value: T) => unknown = identity
) {
  const index = array.findIndex((v) => key(v) === key(element));
  return array.filter((_, i) => i !== index);
}

export function findIndex<T>(
  array: T[] | null | undefined,
  element: T,
  key: (element: T) => unknown = identity
): number | undefined {
  if (!array) return undefined;
  const index = array.findIndex((x) => key(x) === key(element));
  return index < 0 ? undefined : index;
}
